const request = require('./request-promise-lite/lib');

const BASE_URL = process.env.REACT_APP_ROOT_URL;

export default document.req = (options) => {
	return request.get(BASE_URL + options.uri, {json: true});
}


// WEBPACK FOOTER //
// ./src/wp-json-request.js